import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="28sl0cofgp6ar">
      <div lang="fr" className="w-full bg-paper font-sans text-ink antialiased" data-id="element-1" data-mp="23vuokdaowwv5">
        <CountdownBar data-id="element-2" data-mp="3ijxnsm94vshs" />
        <main data-id="element-3" data-mp="3ikh5q2ysagvt">
          <Hero data-id="element-4" data-mp="3iiwfuqnezm4a" />
          <StatsBar data-id="element-5" data-mp="3ijfvg0pldyf5" />
          <Difference data-id="element-6" data-mp="3ihuyk4ft23e4" />
          <Recognize data-id="element-7" data-mp="3mlavz2zp87rv" />
          <WhatsInside data-id="element-8" data-mp="3mkrcviybbdc9" />
          <InsidePages data-id="element-9" data-mp="3mjzrt22ccy08" />
          <Bonuses data-id="element-10" data-mp="3mjgclt42snpw" />
          <Offer data-id="element-11" data-mp="3rcj5s04xxv5k" />
          <Guarantee data-id="element-12" data-mp="3rbzmog3k10py" />
          <Testimonials data-id="element-13" data-mp="3rdkg22e4udm8" />
          <Faq data-id="element-14" data-mp="3recdzjv7cnfo" />
        </main>
        <Footer data-id="element-15" data-mp="5or2zhbcs60" />
      </div>
    </MotionConfig>;
}